import { cn, useFormField } from '@wellesley/ui'
import { Info } from 'lucide-react'

type FieldCaptionProps = {
  caption?: string
  disabled?: boolean
}

const FieldCaption = ({ caption, disabled }: FieldCaptionProps) => {
  const { error } = useFormField()

  if (!caption || !!error) return null

  return (
    <div
      className={cn(
        'mt-xxs flex items-start gap-1 text-sm text-gray-500 transition-all',
        disabled && 'select-none text-gray-300',
      )}
    >
      <Info size={16} />
      {caption}
    </div>
  )
}

export default FieldCaption
